// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"582":"c7651327","986":"e609cc7c"}[chunkId] + ".chunk.js";
};